export const SET_PROFILES = 'events/SET_PROFILES';

/**
 * @param payload
 * @returns {{payload: *, type: string}}
 */
export const setProfiles = (payload) => ({ type: SET_PROFILES, payload });
